/** @format */

import { REGISTER_TYPE } from './index';

const LOCIZE_TEXT_KEYS = {
  INSTRESSEANMALAN: 'intresseanmalan'
};

export const getTranslation = (props) => {
  const { registerType } = props;
  const text = props.t('lang_registration:register');

  const commonFormErrors = {
    firstName: props.t(
      'lang_registration:register.messages.validation.firstNameRequired'
    ),
    lastName: props.t(
      'lang_registration:register.messages.validation.lastNameRequired'
    ),
    email: props.t(
      'lang_registration:register.messages.validation.emailRequired'
    ),
    emailInvalid: props.t(
      'lang_registration:register.messages.validation.emailInvalid'
    )
  };

  const abroadEnglishVersion = {
    mainHeading: text?.abroad?.mainHeading,
    descriptionFirstLine: text?.abroad?.descriptionFirstLine,
    descriptionSecondLine: text?.abroad?.descriptionSecondLine,
    firstName: text?.abroad?.firstName,
    lastName: text?.abroad?.lastName,
    email: text?.abroad?.email,
    message: text?.abroad?.message,
    placeholder: text?.abroad?.placeholder,
    moreInfo: text?.abroad?.moreInfo,
    sendButtonText: text?.abroad?.sendButtonText,
    formErrors: commonFormErrors,
    sentSuccess: text?.abroad?.sentSuccess
  };

  const intresseanmalanVersion = {
    mainHeading: text?.[LOCIZE_TEXT_KEYS.INSTRESSEANMALAN]?.mainHeading,
    descriptionFirstLine:
      text?.[LOCIZE_TEXT_KEYS.INSTRESSEANMALAN]?.descriptionFirstLine,
    descriptionSecondLine:
      text?.[LOCIZE_TEXT_KEYS.INSTRESSEANMALAN]?.descriptionSecondLine,
    firstName: text?.abroad?.firstName,
    lastName: text?.abroad?.lastName,
    email: text?.abroad?.email,
    message: text?.[LOCIZE_TEXT_KEYS.INSTRESSEANMALAN]?.message,
    placeholder: text?.abroad?.placeholder,
    moreInfo: text?.abroad?.moreInfo,
    sendButtonText: text?.abroad?.sendButtonText,
    formErrors: commonFormErrors,
    sentSuccess: text?.abroad?.sentSuccess
  };

  const localSwedishVersion = {
    mainHeading: text.heading,
    firstName: text.form_label_1,
    lastName: text.form_label_2,
    email: text.form_label_3,
    placeholder: text.placeholder,
    moreInfo: props.tprop.buttons[0].label,
    sendButtonText: props.tprop.buttons[1].label,
    formErrors: commonFormErrors,
    sentSuccess: props.t(
      'lang_registration:register.messages.apiSuccessMessages.RB_Success'
    )
  };

  const brokerVersion = {
    mainHeading: text?.broker?.mainHeading,
    description: text?.broker?.description,
    firstName: text.form_label_1,
    lastName: text.form_label_2,
    email: text.form_label_3,
    placeholder: text.placeholder,
    moreInfo: props.tprop.buttons[0].label,
    sendButtonText: props.tprop.buttons[1].label,
    formErrors: commonFormErrors,
    sentSuccess: props.t(
      'lang_registration:register.messages.apiSuccessMessages.RB_Success'
    )
  };

  switch (registerType) {
    case REGISTER_TYPE.ABROAD:
      return abroadEnglishVersion;

    case REGISTER_TYPE.INTRESSEANMALAN2025:
      return intresseanmalanVersion;

    case REGISTER_TYPE.NORMAL:
      return localSwedishVersion;

    case REGISTER_TYPE.BROKER:
      return brokerVersion;

    default:
      return localSwedishVersion;
  }
};
